import clsx from 'clsx';

import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import ReportUserRow from './ReportUserRow';
import { ReportUser } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  users: ReportUser[];
  isCompletedOrAbove: boolean;
}

const ReportUsers = ({ users, isCompletedOrAbove }: Props) => {
  const showUsers = !isNilOrEmpty(users);

  return (
    showUsers && (
      <>
        <div className={classes.usersTableHeader}>
          <div className={classes.usersTableSubHeader}>
            <div className={clsx(classes.usersHeaderCell, classes.name)}>
              Name
            </div>
            <div className={classes.usersHeaderCell}>Hours</div>
          </div>
          {isCompletedOrAbove && (
            <div className={clsx(classes.usersHeaderCell, classes.cost)}>
              Cost
            </div>
          )}
        </div>
        {users.map(user => (
          <ReportUserRow
            key={user.userId}
            user={user}
            isCompletedOrAbove={isCompletedOrAbove}
          />
        ))}
      </>
    )
  );
};

export default ReportUsers;
